export const TOOL_STATUS = {
  READY: 'ready',
  SOON: 'soon',
};

export const TOOL_CATEGORY = {
  ADS: 'ads',
  FINANCE: 'finance',
};

export const toolSections = [
  {
    id: TOOL_CATEGORY.ADS,
    titlePrefix: 'Реклама и ',
    titleEmphasis: 'таргет',
    lead: 'Калькуляторы, шаблоны и чеклисты для планирования рекламы, оценки эффективности и подготовки к запуску таргета.',
  },
  {
    id: TOOL_CATEGORY.FINANCE,
    titlePrefix: 'Финансы и ',
    titleEmphasis: 'экономика',
    lead: 'Юнит-экономика, точка безубыточности, запуск бизнеса и рычаги прибыли — считайте цифры до решений.',
  },
];

export const tools = [
  {
    id: 'startup-calculator',
    slug: 'startup-calculator',
    category: TOOL_CATEGORY.FINANCE,
    name: 'Калькулятор запуска бизнеса',
    description: 'Введите желаемую прибыль и расходы — узнайте, сколько нужно продать, какой минимальный чек и когда выйдете в плюс.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#eeedfe',
    accentColor: '#5340b0',
    icon: 'startup',
  },
  {
    id: 'business-calculator',
    category: TOOL_CATEGORY.FINANCE,
    slug: 'business-calculator',
    name: 'Бизнес-калькулятор (товарный бизнес)',
    description: 'Считает себестоимость, валовую прибыль, точку безубыточности и сколько нужно продать, чтобы заработать нужную сумму.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#fdf0ed',
    accentColor: '#9a3d28',
    icon: 'business',
  },
  {
    id: 'economics-minimum',
    slug: 'economics-minimum',
    category: TOOL_CATEGORY.FINANCE,
    name: 'Экономика на минималках',
    description: 'Введите показатели бизнеса — посчитайте прибыль на продажу, допустимый CPL и план на следующий месяц.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#e8f4f0',
    accentColor: '#1d6b52',
    icon: 'economics',
  },
  {
    id: 'cpl-calculator',
    slug: 'cpl-calculator',
    category: TOOL_CATEGORY.ADS,
    name: 'Калькулятор CPL',
    description: 'Допустимая стоимость заявки — от вашей маржи, конверсии продаж и LTV. Ваша красная линия в переговорах с таргетологом.',
    status: TOOL_STATUS.READY,
    featured: true,
    badge: 'ready',
    accentBg: 'var(--green-light)',
    accentColor: 'var(--green)',
    icon: 'cpl',
    preview: {
      title: 'Макс. CPL',
      value: '4 500 ₸',
      rows: [
        { label: 'Маржа', value: '15 000 ₸' },
        { label: 'CAC', value: '3 750 ₸' },
      ],
      barWidth: '75%',
      barAfterLabel: 'Маржа',
    },
  },
  {
    id: 'profit-control',
    slug: 'profit-control',
    category: TOOL_CATEGORY.FINANCE,
    name: '6 рычагов управления прибылью',
    description: 'Двигайте любой рычаг — сразу видите, как меняется прибыль. Найдите, за что тянуть в первую очередь.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#eeedfe',
    accentColor: '#5340b0',
    icon: 'profit',
  },
  {
    id: 'revenue-levers',
    slug: 'revenue-levers',
    category: TOOL_CATEGORY.FINANCE,
    name: 'Рычаги роста выручки',
    description: 'Введите текущие показатели и желаемую выручку — получите полный расклад, как и на сколько увеличить лиды, конверсию, средний чек и покупки.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#fdf0ed',
    accentColor: 'var(--accent)',
    icon: 'revenue',
  },
  {
    id: 'budget-planner',
    slug: 'budget-planner',
    category: TOOL_CATEGORY.ADS,
    name: 'Планировщик бюджета',
    description: 'Введи желаемое количество клиентов — получи нужный бюджет, прогноз заявок и ROMI с тремя сценариями.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: 'var(--accent-light)',
    accentColor: 'var(--accent)',
    icon: 'budget',
  },
  {
    id: 'target-audit',
    slug: 'target-audit',
    category: TOOL_CATEGORY.ADS,
    name: 'Аудит готовности к таргету',
    description: 'Чеклист: посадочная, оффер, скорость обработки заявок, пиксель, UTM — готов ли бизнес к запуску.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#faeeda',
    accentColor: '#854f0b',
    icon: 'audit',
  },
  {
    id: 'brief-generator',
    slug: 'brief-generator',
    category: TOOL_CATEGORY.ADS,
    name: 'Генератор брифа',
    description: 'Ответьте на вопросы — получите готовый бриф, который можно скопировать и отправить специалисту. Займёт 5–7 минут.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#e6f1fb',
    accentColor: '#185fa5',
    icon: 'brief',
  },
  {
    id: 'audience-builder',
    slug: 'audience-builder',
    category: TOOL_CATEGORY.ADS,
    name: 'Конструктор портрета ЦА',
    description: 'JTBD-конструктор: гипотезы сегментов, «работ», боли, выгоды, каналы и приоритеты по данным о вашем бизнесе.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#fbeaf0',
    accentColor: '#993556',
    icon: 'audience',
  },
  {
    id: 'marketing-diagnostic',
    slug: 'marketing-diagnostic',
    category: TOOL_CATEGORY.FINANCE,
    name: 'Диагностика маркетинга',
    description: 'Точка А, цель по выручке, CPL, ROMI и 4 рычага роста — узнайте, за счёт чего быстрее выйти на цель.',
    status: TOOL_STATUS.READY,
    featured: true,
    badge: 'ready',
    accentBg: '#fdf0ed',
    accentColor: 'var(--accent)',
    icon: 'revenue',
  },
  {
    id: 'romi-tracker',
    slug: 'romi-tracker',
    category: TOOL_CATEGORY.ADS,
    name: 'Трекер ROMI по неделям',
    description: 'Еженедельный ввод данных по кампании — динамика CPL и ROMI на графике, итог за месяц.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: 'var(--green-light)',
    accentColor: 'var(--green)',
    icon: 'romi',
  },
  {
    id: 'report-checklist',
    slug: 'report-checklist',
    category: TOOL_CATEGORY.ADS,
    name: 'Чеклист приёмки отчёта',
    description: 'Что проверить в отчёте таргетолога: какие метрики должны быть и какие вопросы задать.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#faeeda',
    accentColor: '#854f0b',
    icon: 'report',
  },
  {
    id: 'scale-calculator',
    slug: 'scale-calculator',
    category: TOOL_CATEGORY.FINANCE,
    name: 'Калькулятор масштабирования',
    description: 'Что будет если удвоить бюджет — прогноз заявок и выручки с учётом роста CPL.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: 'var(--accent-light)',
    accentColor: 'var(--accent)',
    icon: 'scale',
  },
  {
    id: 'channel-compare',
    slug: 'channel-compare',
    category: TOOL_CATEGORY.ADS,
    name: 'Сравнение каналов трафика',
    description: 'Instagram, TikTok, Google — сравни CPL и ROMI по каналам в одном экране.',
    status: TOOL_STATUS.READY,
    featured: false,
    badge: 'ready',
    accentBg: '#e6f1fb',
    accentColor: '#185fa5',
    icon: 'channels',
  },
];

export const getToolBySlug = (slug) => tools.find((tool) => tool.slug === slug);

export const getToolsByCategory = (category) =>
  tools.filter((tool) => tool.category === category);

export const getCategoryCounts = (category) => {
  const categoryTools = getToolsByCategory(category);

  return {
    ready: categoryTools.filter((tool) => tool.status === TOOL_STATUS.READY).length,
    soon: categoryTools.filter((tool) => tool.status === TOOL_STATUS.SOON).length,
  };
};

export const getReadyToolsCount = () =>
  tools.filter((tool) => tool.status === TOOL_STATUS.READY).length;

export const getSoonToolsCount = () =>
  tools.filter((tool) => tool.status === TOOL_STATUS.SOON).length;
